import { all, select, takeEvery, fork, put, call } from 'redux-saga/effects'

// action
import { customerOrderActions } from '@redux/store/index'

// lib
import { Logger } from '@utils'

// api
import { orderApi, ResType } from '@api'

// schemas
import { Order, CustomerType } from '@schemas'

const apiGetCustomerOrder = async (
	query: {
		customerId: string
	},
	accessToken: string,
): Promise<ResType | undefined> => {
	const customHeaders = { Authorization: `Bearer ${accessToken}` }
	const res: ResType | undefined = await orderApi.getOrderCustomer({
		query: query,
		customHeaders: customHeaders,
	})
	return res
}

function* triggerInitCustomerOrderPageSaga() {
	try {
		const customer: CustomerType = yield select(state => state.customerAuth.customer)

		yield put(customerOrderActions.ORDER_LIST_STATUS('loading'))
		const sessionAccessToken = sessionStorage.getItem('accessCustomerToken')

		if (customer.id !== '' && sessionAccessToken !== null && sessionAccessToken !== '') {
			const query = {
				customerId: customer.id,
			}
			const apiRes: ResType = yield call(apiGetCustomerOrder, query, sessionAccessToken)

			if (apiRes.status === 200) {
				const data = Array.isArray(apiRes.data) ? (apiRes.data as any[]) : []
				const newOrderList = data.map(aData => new Order(aData))

				yield put(customerOrderActions.ORDER_LIST(newOrderList))
				// 주문이 없어도 서버는 200 + 빈 배열을 준다. 'ok' 로 두면 빈 목록을 그려 아무것도 안 보이므로
				// 비었으면 'empty' — 페이지가 "No orders yet." 을 찍는다 (2026-09-26)
				yield put(
					customerOrderActions.ORDER_LIST_STATUS(
						newOrderList.length === 0 ? 'empty' : 'ok',
					),
				)
			} else {
				yield put(customerOrderActions.ORDER_LIST_STATUS('empty'))
			}
		} else {
			yield put(customerOrderActions.ORDER_LIST_STATUS('empty'))
		}
		yield
	} catch (error) {
		Logger.warn(error)
	}
}

function* mainSaga() {
	yield takeEvery(
		customerOrderActions.TRIGGER_INIT_CUSTOMER_ORDER_PAGE,
		triggerInitCustomerOrderPageSaga,
	)
}

export default function* rootSaga() {
	yield all([fork(mainSaga)])
}
